import { AssociarProdutoItemAvulsoRequest } from './associar-produto-item-avulso.request';

/** Vínculo em lote dos itens avulsos a produtos do cadastro, com os avulsos removidos da compra. */
export class AssociarProdutoItensAvulsosRequest {
  itens: AssociarProdutoItemAvulsoRequest[] = [];
  idsCompraItemRemover: number[] = [];
}
